import { render, staticRenderFns } from "./wordPage.vue?vue&type=template&id=04fd0ab8&scoped=true"
import script from "./wordPage.vue?vue&type=script&lang=js"
export * from "./wordPage.vue?vue&type=script&lang=js"
import style0 from "./wordPage.vue?vue&type=style&index=0&id=04fd0ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fd0ab8",
  null
  
)

export default component.exports